import { PAGES } from '@/consts';
import { Schema } from '@/entities/schema';
import { ImageShape } from '../lib/types';
import { axiosAPI } from './axios-instance';
import { ApiRequestFnParams, ApiResponse } from './lib/types';

export type ApiSchemesRequest =
    | {
          page: PAGES;
      }
    | {
          event: number;
      };

export type ApiSchemesResponse = ApiResponse<
    {
        id: number;
        slug: string;
        name: string;
        description?: string;
        image: ImageShape;
    }[]
>;

export type AppSchemesResponse = ApiResponse<Schema[]>;

const transformApiResponse = (response: ApiSchemesResponse): AppSchemesResponse => {
    return {
        ...response,
        data: (response.data || []).map((item) => ({
            id: item.id,
            slug: item.slug,
            name: item.name,
            text: item.description || null,
            img: item.image,
        })),
    };
};

export const getSchemes = ({ params }: ApiRequestFnParams<ApiSchemesRequest> = {}): Promise<AppSchemesResponse> =>
    axiosAPI.get<ApiSchemesResponse>('/v1/schemes', { params }).then((res) => transformApiResponse(res.data));
